
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type {
    CollectionMediaType,
    CollectionMediaPayloadType,
} from "@/common/types/collection-media";

export async function collectionMediaList(
    collection_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/${collection_id}/media/list${queryString}`
    );
}

export async function collectionMediaGet(
    item_id: string
) {
    return await clientAxios.get(
        `collection/media/${item_id}/show`
    );
}

export async function collectionMediaCreate(
    collection_id: string,
    payload: CollectionMediaPayloadType
) {
    return await clientAxios.post(
        `collection/${collection_id}/media/create`,
        payload
    );
}

export async function collectionMediaPatch(
    item_id: string,
    payload: Partial<CollectionMediaType>
) {
    return await clientAxios.patch(
        `collection/media/${item_id}/patch`,
        { payload }
    );
}

export async function collectionMediaDel(
    item_id: string,
) {
    return await clientAxios.del(
        `collection/media/${item_id}/delete`,
    );
}
